import Vue from 'vue';

import AwardsWidget from './components/AwardsWidget.vue';
import VueCompositionApi from "@vue/composition-api";
import Vuex from "vuex"
import {root} from "@/shared/store";
import {AwardsWidgetState} from "@/apps/AwardsWidget/models/awards-widget-state";
import mutations from "@/apps/AwardsWidget/store/mutations";
import actions from "@/apps/AwardsWidget/store/actions";

Vue.use(VueCompositionApi);
Vue.use(Vuex);

document.querySelectorAll('widget-awards').forEach(el => {
    let store = new Vuex.Store({
        state: new AwardsWidgetState,
        actions: actions,
        mutations: mutations,
        modules: {
            root
        }
    })

    new Vue({
        el: el,
        store,
        render(h: any) {
            let title = this.$el.attributes.getNamedItem('title');
            let json = this.$el.attributes.getNamedItem('json');

            return h(AwardsWidget, {
                props: {
                    title: title ? title.value : null,
                    categories: json ? JSON.parse(json.value) : []
                }
            })
        }
    });
});
